import "./youtubeChannelSection.css";

const CHANNEL_URL = "https://www.youtube.com/@JeanClaudeBramly";
const PLAYLIST_URL = "https://www.youtube.com/watch?v=Mit9QDjR8cc&list=PLDI_T_ldcS5rciyvVxvwI3hQ5ssiGP-1x";
const VIDEOS = [
	{
		title: "Pollutia - Teaser",
		id: "eJeowvFtybo",
	},
	{
		title: "Big Mother - Teaser",
		id: "Mit9QDjR8cc",
	},
	{
		title:"On a volé le LA - teaser",
		id:"iRRJOs2U1WI",
	},
	{
		title : "Les Contes de La Rochelle - Extrait",
		id : "k7X1fl40vPU"
	},
	{
		title: "J'en veux - Extrait de Big Mother",
		id: "lXw0l1CZ9IU",
	},
	{
		title: "Amnésia - Extrait",
		id: "YYYWqjzOdc0",
	},
	{
		title: "L'Étoile de Poubo - La chanson de l'arbre",
		id: "Xt4v_gTXhQs",
	},
	{
		title: "J'ai tout donné - Extrait de BigMother",
		id: "97-LQlJgPS8",
	},
	{
		title : "Passage sur RTL - On a volé le LA ",
		id : "G3Ffx2NBD3s"
	}, 
	{
		title: "La complainte d'Ophélie",
		id: "t9_FNr9HswM",
	},
];

const YoutubeChannelSection = () => {
	return (
		<div className="yt-channel-section">
			<div className="yt-channel-header">
				<div className="yt-channel-logo">
					<svg viewBox="0 0 16 16" fill="currentColor" width="36" height="36">
						<path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z" />
					</svg>
				</div>
				<div className="yt-channel-info">
					<h2 className="yt-channel-title">La Boitazik</h2>
					<p className="yt-channel-subtitle">
						Découvrez nos spectacles en vidéo
					</p>
				</div>
				<a
					href={PLAYLIST_URL}
					target="_blank"
					rel="noreferrer"
					className="yt-subscribe-btn"
				>
					<svg viewBox="0 0 16 16" fill="currentColor" width="18" height="18">
						<path d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.007 2.007 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.007 2.007 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31.4 31.4 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.007 2.007 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A99.788 99.788 0 0 1 7.858 2h.193zM6.4 5.209v4.818l4.157-2.408L6.4 5.209z" />
					</svg>
					S'abonner
				</a>
			</div>

			<div className="yt-channel-grid">
				{VIDEOS.map((video, index) => (
					<div className="yt-channel-card" key={index}>
						<div className="yt-channel-player">
							<iframe
								src={`https://www.youtube.com/embed/${video.id}`}
								title={video.title}
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
								allowFullScreen
								className="yt-channel-iframe"
							></iframe>
						</div>
						<p className="yt-channel-video-title">{video.title}</p>
					</div>
				))}
			</div>

			<div className="yt-channel-footer">
				<a
					href={PLAYLIST_URL}
					target="_blank"
					rel="noreferrer"
					className="yt-channel-link"
				>
					Voir toutes les vidéos sur YouTube
					<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
						<path
							fillRule="evenodd"
							d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
						/>
					</svg>
				</a>
			</div>
		</div>
	);
};

export default YoutubeChannelSection;
